class WooloraUploadWidget {
  constructor(root) {
    this.root = root;
    this.input = root.querySelector('.woolora-upload__input');
    this.trigger = root.querySelector('[data-upload-trigger]');
    this.preview = root.querySelector('[data-upload-preview]');
    this.progress = root.querySelector('[data-upload-progress]');
    this.urlsInput = root.querySelector('[data-upload-urls]');
    this.files = [];
    this.bind();
    this.render();
  }

  bind() {
    this.trigger?.addEventListener('click', () => this.input?.click());
    this.input?.addEventListener('change', (event) => this.handleFiles(event.target.files));
  }

  async handleFiles(fileList) {
    const selectedFiles = [...fileList];
    for (const file of selectedFiles) {
      const localUrl = URL.createObjectURL(file);
      const item = { file, localUrl, uploadedUrl: '', status: 'uploading' };
      this.files.push(item);
      this.render();
      await this.uploadFile(item);
    }
    this.syncUrls();
  }

  async uploadFile(item) {
    if (!window.WOOLORA_CLOUDINARY_CLOUD || !window.WOOLORA_CLOUDINARY_PRESET) {
      item.uploadedUrl = item.file.name;
      item.status = 'ready';
      this.render();
      this.syncUrls();
      return;
    }

    const formData = new FormData();
    formData.append('file', item.file);
    formData.append('upload_preset', window.WOOLORA_CLOUDINARY_PRESET);

    try {
      const request = await fetch(`https://api.cloudinary.com/v1_1/${window.WOOLORA_CLOUDINARY_CLOUD}/image/upload`, {
        method: 'POST',
        body: formData
      });

      if (!request.ok) throw new Error('Image upload failed');
      const response = await request.json();
      item.uploadedUrl = response.secure_url;
      item.status = 'ready';
    } catch (error) {
      item.status = 'failed';
      console.error(error);
    }

    this.render();
    this.syncUrls();
  }

  remove(index) {
    const [removed] = this.files.splice(index, 1);
    if (removed?.localUrl) URL.revokeObjectURL(removed.localUrl);
    this.render();
    this.syncUrls();
  }

  syncUrls() {
    this.urlsInput.value = this.files
      .map((item) => item.uploadedUrl)
      .filter(Boolean)
      .join('\n');
  }

  render() {
    const total = this.files.length;
    const ready = this.files.filter((item) => item.status === 'ready').length;
    const failed = this.files.filter((item) => item.status === 'failed').length;

    if (!total) {
      this.progress.textContent = 'Waiting for photos';
    } else if (failed) {
      this.progress.textContent = `${ready}/${total} uploaded, ${failed} failed`;
    } else {
      this.progress.textContent = `${ready}/${total} uploaded`;
    }

    this.preview.innerHTML = this.files.map((item, index) => `
      <div class="woolora-upload-thumb" data-status="${item.status}">
        <img src="${item.localUrl}" alt="Pet upload preview">
        <span>${item.status === 'uploading' ? 'Uploading' : item.status === 'failed' ? 'Failed' : 'Ready'}</span>
        <button type="button" data-remove-upload="${index}" aria-label="Remove image">×</button>
      </div>
    `).join('');

    this.preview.querySelectorAll('[data-remove-upload]').forEach((button) => {
      button.addEventListener('click', () => this.remove(Number(button.dataset.removeUpload)));
    });
  }
}

document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll('[data-upload-widget]').forEach((root) => new WooloraUploadWidget(root));
});
